var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgDownloadGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.516 50H6.484C2.911 50 0 47.182 0 43.75V6.25C0 2.805 2.911 0 6.484 0h162.032C172.086 0 175 2.805 175 6.25v37.5c0 3.432-2.914 6.25-6.484 6.25z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.516 1.001c2.997 0 5.45 2.359 5.45 5.249v37.5c0 2.89-2.437 5.249-5.45 5.249H6.484c-2.997 0-5.45-2.359-5.45-5.249V6.25c0-2.89 2.437-5.249 5.45-5.249h162.032zm0-1.001H6.484C2.911 0 0 2.818 0 6.25v37.5C0 47.194 2.911 50 6.484 50h162.032c3.57 0 6.484-2.806 6.484-6.25V6.25c0-3.432-2.914-6.25-6.484-6.25z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.191 16.54c-1.169 0-2.155-.396-2.933-1.175a3.941 3.941 0 01-1.185-2.868c0-1.138.4-2.101 1.185-2.865.775-.779 1.761-1.175 2.93-1.175 1.155 0 2.14.396 2.933 1.175a3.931 3.931 0 011.184 2.865c-.013 1.141-.412 2.104-1.184 2.865-.777.785-1.762 1.178-2.93 1.178zm-34.773 0c-1.142 0-2.134-.39-2.946-1.159-.804-.767-1.214-1.737-1.214-2.881 0-1.144.41-2.113 1.214-2.88.796-.77 1.787-1.16 2.946-1.16a4.22 4.22 0 011.646.331c.517.215.939.508 1.252.866l.077.091-.873.829-.089-.103c-.493-.567-1.153-.845-2.026-.845a2.85 2.85 0 00-2.019.798c-.563.533-.849 1.232-.849 2.076 0 .845.286 1.543.849 2.076a2.85 2.85 0 002.019.798c.831 0 1.53-.268 2.074-.798.322-.311.521-.748.592-1.299h-2.798v-1.166h3.999l.016.106c.028.196.058.399.058.586 0 1.075-.335 1.945-.998 2.587-.753.761-1.739 1.147-2.93 1.147zm46.233-.165h-1.233l-3.775-5.851.032 1.054v4.794h-1.233V8.626h1.407l.038.059 3.55 5.511-.032-1.05v-4.52h1.246v7.749zm-20.726 0h-1.249V9.791h-2.167V8.626h5.58v1.165h-2.167v6.584h.003zm-4.432 0h-1.247V8.626h1.247v7.749zm-7.002 0h-1.247V9.791h-2.167V8.626h5.58v1.165h-2.166v6.584zm-4.202-.013h-4.778V8.626h4.778v1.165H63.76v2.126h3.185v1.154H63.76v2.126h3.529v1.165zm22.883-1.798c.557.539 1.233.81 2.019.81.807 0 1.468-.265 2.018-.81.547-.53.824-1.225.824-2.064 0-.838-.277-1.537-.821-2.063a2.805 2.805 0 00-2.018-.811c-.808 0-1.469.265-2.016.811-.547.53-.823 1.225-.823 2.063 0 .839.273 1.537.817 2.064z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.957 27.194c-3.042 0-5.508 2.235-5.508 5.318 0 3.055 2.482 5.318 5.508 5.318 3.042 0 5.508-2.25 5.508-5.318 0-3.083-2.466-5.318-5.508-5.318zm0 8.529c-1.665 0-3.097-1.334-3.097-3.223 0-1.917 1.436-3.223 3.097-3.223 1.664 0 3.097 1.306 3.097 3.223.003 1.901-1.433 3.223-3.097 3.223zm-12.018-8.529c-3.042 0-5.509 2.235-5.509 5.318 0 3.055 2.483 5.318 5.509 5.318 3.042 0 5.508-2.25 5.508-5.318 0-3.083-2.469-5.318-5.508-5.318zm0 8.529c-1.665 0-3.097-1.334-3.097-3.223 0-1.917 1.435-3.223 3.097-3.223 1.664 0 3.097 1.306 3.097 3.223 0 1.901-1.433 3.223-3.097 3.223zm-14.301-6.905v2.251h5.58c-.171 1.263-.602 2.195-1.262 2.834-.818.791-2.08 1.652-4.305 1.652-3.428 0-6.11-2.681-6.11-6.001 0-3.32 2.682-6.001 6.11-6.001 1.852 0 3.201.708 4.201 1.612l1.649-1.596c-1.391-1.29-3.242-2.279-5.837-2.279-4.704 0-8.65 3.71-8.65 8.252 0 4.554 3.943 8.251 8.65 8.251 2.54 0 4.446-.804 5.952-2.319 1.536-1.487 2.023-3.585 2.023-5.278 0-.527-.042-1-.129-1.402h-7.875c.003-.004.003.024.003.024zm58.493 1.752c-.459-1.194-1.85-3.388-4.702-3.388-2.828 0-5.178 2.154-5.178 5.318 0 2.986 2.324 5.318 5.451 5.318a5.485 5.485 0 004.574-2.36l-1.863-1.209c-.619.888-1.479 1.471-2.699 1.471-1.233 0-2.096-.542-2.668-1.612l7.343-2.945c0 .003-.258-.593-.258-.593zm-7.487 1.777c-.059-2.054 1.648-3.098 2.868-3.098.963 0 1.764.458 2.038 1.125l-4.906 1.973zm-5.965 5.153h2.409V21.876h-2.409V37.5zm-3.961-9.124h-.088c-.544-.627-1.577-1.194-2.896-1.194-2.74 0-5.264 2.335-5.264 5.334 0 2.986 2.511 5.292 5.264 5.292 1.303 0 2.352-.57 2.896-1.209h.088v.764c0 2.029-1.119 3.123-2.927 3.123-1.477 0-2.394-1.029-2.769-1.889l-2.095.848a5.237 5.237 0 004.861 3.139c2.826 0 5.222-1.611 5.222-5.542V27.5h-2.279v.876h-.013zm-2.769 7.347c-1.664 0-3.055-1.347-3.055-3.207 0-1.877 1.391-3.236 3.055-3.236 1.65 0 2.927 1.374 2.927 3.236.016 1.86-1.274 3.207-2.927 3.207zm31.473-13.847h-5.766V37.5h2.412v-5.917h3.357c2.669 0 5.293-1.873 5.293-4.847s-2.615-4.86-5.296-4.86zm.07 7.525h-3.427V24.04h3.427c1.808 0 2.829 1.443 2.829 2.681 0 1.225-1.034 2.68-2.829 2.68zm14.89-2.235c-1.752 0-3.557.752-4.303 2.388l2.137.86c.461-.86 1.305-1.153 2.196-1.153 1.249 0 2.511.723 2.539 2.014v.165c-.43-.237-1.378-.598-2.51-.598-2.308 0-4.65 1.221-4.65 3.513 0 2.098 1.894 3.444 4.002 3.444 1.619 0 2.511-.707 3.069-1.527h.086v1.209h2.324v-5.985c0-2.787-2.137-4.33-4.89-4.33zm-.301 8.557c-.79 0-1.894-.374-1.894-1.334 0-1.21 1.378-1.668 2.554-1.668 1.062 0 1.563.222 2.195.527-.174 1.403-1.398 2.463-2.855 2.475zm13.672-8.223l-2.769 6.777h-.086l-2.87-6.777h-2.595l4.305 9.473-2.453 5.265h2.511l6.622-14.738h-2.665zm-21.705 10h2.412V21.876h-2.412V37.5z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.47 9.417c-.373.39-.589.985-.589 1.764v27.641c0 .779.216 1.374.602 1.748l.1.085 15.994-15.487v-.346L13.57 9.333l-.1.084z",
    fill: "url(#img_download_google_play_svg__paint0_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.898 30.346l-5.334-5.165v-.362l5.334-5.165.116.068 6.31 3.473c1.806.985 1.806 2.612 0 3.61l-6.31 3.472-.116.069z",
    fill: "url(#img_download_google_play_svg__paint1_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.014 30.277L29.564 25 13.47 40.583c.589.611 1.577.679 2.681.084l18.863-10.39z",
    fill: "url(#img_download_google_play_svg__paint2_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.014 19.722L16.151 9.348c-1.104-.611-2.095-.526-2.681.085L29.564 25l5.45-5.278z",
    fill: "url(#img_download_google_play_svg__paint3_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.898 30.165L16.164 40.471c-1.046.583-1.979.542-2.581.012l-.1.097.1.084c.602.527 1.535.57 2.581-.013l18.863-10.374-.129-.112z",
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.324 26.624l-6.442 3.541.116.112 6.31-3.472c.904-.499 1.349-1.154 1.349-1.805-.055.598-.515 1.166-1.333 1.624z",
    fill: "#000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.151 9.529l25.173 13.847c.818.445 1.278 1.028 1.349 1.624 0-.652-.444-1.306-1.349-1.805L16.151 9.348c-1.805-1-3.27-.165-3.27 1.833v.181c0-2.001 1.465-2.821 3.27-1.833z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "img_download_google_play_svg__paint0_linear",
    x1: 27.82,
    y1: 10.883,
    x2: 2.565,
    y2: 17.754,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(1.01156 1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "img_download_google_play_svg__paint1_linear",
    x1: 43.18,
    y1: 25,
    x2: 12.3,
    y2: 25,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(1.01156 1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "img_download_google_play_svg__paint2_linear",
    x1: 31.684,
    y1: 27.872,
    x2: 11.97,
    y2: 61.749,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(1.01156 1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "img_download_google_play_svg__paint3_linear",
    x1: 9.31,
    y1: 0.223,
    x2: 18.105,
    y2: 15.353,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(1.01156 1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
export default SvgImgDownloadGooglePlay;